import React from 'react'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import './Login.css'
import Textbox from '../../components/Textbox/Textbox'
import Button from '../../components/Button/Button'
import LinkedText from '../../components/LinkedText/LinkedText'
import { Colors } from '../../design/Colors'
import { Fonts } from '../../design/Font'
import u11_state0 from "../../images/hsa-user_login/u11_state0.jpg"
import Checkbox from '../../components/Checkbox/Checkbox'

export default class Login extends React.Component{

    constructor(props){
        super(props);
        this.state={
            username:null,
            password:null,
            remember:true,
            show_password:false,
            username_error:null,
            password_error:null
        }
    }
    
    submitLogin= async ()=>{
        
        const {username,password}=this.state
        
        const hard_username = process.env.REACT_APP_ADMIN_USERNAME
        const hard_password = process.env.REACT_APP_ADMIN_PASSWORD

        if(!username){
            this.setState({username_error:"Must Enter Username"}) 
        }
        if(!password){
            this.setState({password_error:"Must Enter Password"})
            return
        }
        //auth succeeds
        if(username===hard_username && password===hard_password){
            await this.props.setAuth(true);
            this.props.navigator('/Dashboard'); 
            return;
        }

        
            this.setState({username_error:"Incorrect username or password",password_error:"Incorrect username or password"})

        console.log("username: ",username)
        console.log("password: ",password)
    }


    render(){
        return <div style={{height:"100vh",display:'flex',flexDirection:'column',}}>
            <Header/>
            <div style={{display:'flex',flexDirection:'column',backgroundColor:Colors.light_grey,flex:10, justifyContent:'center',alignItems:'center'}}> 
                <div style={{display:'flex',flex:1,flexDirection:'row',justifyContent:'center',backgroundColor:Colors.white,width:"44%", alignSelf:'center', borderRadius:"5px", overflow:'hidden', margin:'10vh'}}>
                    <div style={{display:'flex',flex:7, justifyContent:'center',alignContent:'center'}}><img style={{objectFit:'cover',maxHeight:"100%",maxWidth:"100%"}} src={u11_state0} alt="u11_state0"/></div>
                    <div style={{display:'flex',flex:5,flexDirection:'column', padding:"5%"}}>
                        <div style={{height:"1%"}}/>
                        <span style={{...Fonts.title}}>Login</span>
                        <div style={{height:"7%"}}/>
                        <Textbox title="Username" required={true} onChange={(value)=>{this.setState({username:value.target.value})} } errorMessage={this.state.username_error}></Textbox>
                        <div style={{height:"5%"}}/>
                        <Textbox title="Password" password={true} required={true} onChange={(value)=>{this.setState({password:value.target.value})}} errorMessage={this.state.password_error}></Textbox>
                        <div style={{height:"6%"}}/>
                        <div style={{display:'flex', flex:1,flexDirection:'row',}}>
                            <Checkbox title='Remember me' boxFirst={true} value={this.state.remember} onChange={()=>this.setState({remember:!this.state.remember})}/>
                            <LinkedText title='Lost your password?' align="right" onClick={()=>{console.log("forgot password clicked")}}/>
                        </div>
                        <div style={{height:"5%"}}/>
                        <Button title="LOGIN" onClick={this.submitLogin} height='4.7vh'/>
                        <div style={{height:"11%"}}/>
                        <div style={{display:'flex', flex:1,flexDirection:'row'}}>
                            <span style={{...Fonts.subtext, width:"100%", textAlign:'center'}}>Don't have an account? <span style={{color:Colors.light_blue}}>Enroll now</span></span>
                        </div>
                    </div>
                </div> 
                
            </div>
            <Footer/>
        </div>
    }
}


